export function setUser(payload) {
  return {
    type: 'SET_USER',
    payload
  }
}

export function fetchDataReferensi(payload) { //
  return {
    type: 'FETCH_DATA_REFERENSI',
    payload
  }
}

export function fetchDataNews(payload) { //
  return {
    type: 'FETCH_DATA_NEWS',
    payload
  }
}

export function fetchDataArtikelById(payload) {
  return {
    type: 'FETCH_DATA_ARTIKEL_ID',
    payload
  }
}

export function fetchDataArtikelBySlug(payload) {
  return {
    type: 'FETCH_DATA_ARTIKEL_SLUG',
    payload
  }
}

export function fetchDataBeritaPusatById(payload) {
  return {
    type: 'FETCH_DATA_BERITA_PUSAT_ID',
    payload
  }
}

export function fetchDataBeritaPusatBySlug(payload) {
  return {
    type: 'FETCH_DATA_BERITA_PUSAT_SLUG',
    payload
  }
}

export function fetchDataBeritaDaerahById(payload) {
  return {
    type: 'FETCH_DATA_BERITA_DAERAH_ID',
    payload
  }
}

export function fetchDataBeritaDaerahBySlug(payload) {
  return {
    type: 'FETCH_DATA_BERITA_DAERAH_SLUG',
    payload
  }
}

export function fetchDataOpiniById(payload) {
  return {
    type: 'FETCH_DATA_OPINI_ID',
    payload
  }
}

export function fetchDataOpiniBySlug(payload) {
  return {
    type: 'FETCH_DATA_OPINI_SLUG',
    payload
  }
}

export function fetchDataArtikelPopuler(payload) {
  return {
    type: 'FETCH_DATA_ARTIKEL_POPULER',
    payload
  }
}

export function fetchDataBeritaPusatPopuler(payload) {
  return {
    type: 'FETCH_DATA_BERITA_PUSAT_POPULER',
    payload
  }
}

export function fetchDataBeritaDaerahPopuler(payload) {
  return {
    type: 'FETCH_DATA_BERITA_DAERAH_POPULER',
    payload
  }
}

export function fetchDataOpiniPopuler(payload) {
  return {
    type: 'FETCH_DATA_OPINI_POPULER',
    payload
  }
}

export function fetchDataBeritaPusat(payload) { //
  return {
    type: 'FETCH_DATA_BERITA_PUSAT',
    payload
  }
}

export function fetchDataBeritaDaerah(payload) { //
  return {
    type: 'FETCH_DATA_BERITA_DAERAH',
    payload
  }
}

export function fetchDataArtikel(payload) { //
  return {
    type: 'FETCH_DATA_ARTIKEL',
    payload
  }
}

export function fetchDataOpini(payload) { //
  return {
    type: 'FETCH_DATA_OPINI',
    payload
  }
}

export function fetchDataAdmins() {
  return {
    type: 'FETCH_DATA_ADMINS'
  }
}

export function fetchDataRegions() {
  return {
    type: 'FETCH_DATA_REGIONS'
  }
}

export function fetchDataNotification() {
  return {
    type: 'FETCH_DATA_NOTIFICATION'
  }
}

export function userLogout() {
  return {
    type: 'USER_LOGOUT'
  }
}

export function fetchDataRegistration(payload) {
  return {
    type: 'FETCH_DATA_REGISTRATION',
    payload
  }
}

export function fetchDataRegulation(payload) {
  return {
    type: 'FETCH_DATA_REGULATION',
    payload
  }
}

export function fetchDataQuote(payload) { //
  return {
    type: 'FETCH_DATA_QUOTE',
    payload
  }
}

export function fetchDataReport(payload) {
  return {
    type: 'FETCH_DATA_REPORT',
    payload
  }
}

export function fetchDataLaporan(payload) {
  return {
    type: 'FETCH_DATA_LAPORAN',
    payload
  }
}

export function fetchDataRumahIbadat() {
  return {
    type: 'FETCH_DATA_RUMAH_IBADAT',
  }
}

export function fetchDataListFKUB(payload) {
  return {
    type: 'FETCH_DATA_LIST_FKUB',
    payload
  }
}

export function verificationTokenSSO(payload) {
  return {
    type: 'VERIFICATION_TOKEN',
    payload
  }
}
